import * as React from "react";
import { MediaQuery } from "@grandvisionhq/common";
import { ProductBlockContainerLoader } from "../../../ProductBlockContainerLoader/ProductBlockContainers/ProductBlockContainerLoader/ProductBlockContainerLoader.js";
import { ProductBlockContainerError } from "../../../ProductBlockContainerError/ProductBlockContainers/ProductBlockContainerError/ProductBlockContainerError.js";
import { ProductBlockCarousel } from "../../components/ProductBlockCarousel/ProductBlockContainers/ProductBlockGallery/components/ProductBlockCarousel/ProductBlockCarousel.js";
import { ProductBlockSlider } from "../../components/ProductBlockSlider/ProductBlockContainers/ProductBlockGallery/components/ProductBlockSlider/ProductBlockSlider.js";
const ProductBlockGallery = ({
  isLoading,
  hasError,
  itemsPerSlide,
  navigationLocation,
  shouldCenterSlideItems,
  ...props
}) => {
  const isBigScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(ProductBlockContainerLoader, null);
  }
  if (hasError) {
    return /* @__PURE__ */ React.createElement(ProductBlockContainerError, null);
  }
  if (isBigScreen) {
    return /* @__PURE__ */ React.createElement(
      ProductBlockCarousel,
      {
        itemsPerSlide,
        navigationLocation,
        shouldCenterSlideItems,
        ...props
      }
    );
  }
  return /* @__PURE__ */ React.createElement(ProductBlockSlider, { ...props });
};
export {
  ProductBlockGallery
};
//# sourceMappingURL=ProductBlockGallery.js.map
